import LocationFilter from '../apartmentListFilters/locationFilter';
import PriceFilter from '../apartmentListFilters/priceFilter';
import FrontpageLocationFilter from '../frontpageFilters/frontpageLocationFilter';
import FrontpageRoomCountFilter from '../frontpageFilters/frontpageRoomCountFilter';
import FrontpagePriceFilter from '../frontpageFilters/frontpagePriceFilter';

import {
	APARTMENT_LIST_LOCATION_FILTER,
	APARTMENT_LIST_PRICE_FILTER,
	APARTMENT_LIST_FRONTPAGE_LOCATION_FILTER,
	APARTMENT_LIST_FRONTPAGE_PRICE_FILTER,
	APARTMENT_LIST_FRONTPAGE_ROOM_COUNT_FILTER
} from '../../constants/contextMenus';

const mapper = {
	[APARTMENT_LIST_LOCATION_FILTER]: LocationFilter,
	[APARTMENT_LIST_PRICE_FILTER]: PriceFilter,
	[APARTMENT_LIST_FRONTPAGE_LOCATION_FILTER]: FrontpageLocationFilter,
	[APARTMENT_LIST_FRONTPAGE_PRICE_FILTER]: FrontpagePriceFilter,
	[APARTMENT_LIST_FRONTPAGE_ROOM_COUNT_FILTER]: FrontpageRoomCountFilter
};

export default mapper;
